import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import React from "react";
import { ErrorMessage, useField } from "formik";
import ErrorMessages from "./ErrorMessage";

const PasswordInput = ({ name, ...rest }: { name: string; label: string }) => {
  const [field, meta] = useField(name);
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <>
      <FormControl
        fullWidth
        variant="outlined"
        error={!!meta.touched && !!meta.error}
      >
        <InputLabel>{rest.label}</InputLabel>

        <OutlinedInput
          {...field}
          {...rest}
          type={showPassword ? "text" : "password"}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          label={rest.label}
        />
      </FormControl>

      <ErrorMessages>
        <ErrorMessage name={name} />
      </ErrorMessages>
    </>
  );
};

export default PasswordInput;
